module.exports = __webpack_public_path__ + "img/alert5.png";